import { createSlice } from "@reduxjs/toolkit";

const constestTicketStepper = createSlice({
  name: "constest-ticket-stepper",
  initialState: {
    value: {
      condition: false,
      stepNumber: 2
    }
  },
  reducers: {
    setCondition(state, {payload}){
      state.value.condition = payload
    },
  }
})

export const { setCondition } = constestTicketStepper.actions
export default constestTicketStepper.reducer